import { Button } from 'primereact/button';

const Summary = ({ familyMember, labels, sfd, jumptolasttab, exactPrice, addmember }) =>
    <>
        <h3>{labels.summary}</h3>
        <div className="grid ui-fluid mt-3 summary">
            <div className="col-12 md:col-6">
                <div className="field">
                    <label>{labels.name}</label>
                    <div>{familyMember.name}</div>
                </div>
                <div className="field">
                    <label>{labels.surname}</label>
                    <div>{familyMember.surname}</div>
                </div>
                <div className="field">
                    <label>{labels.birthDate}</label>
                    <div>{(familyMember.birthDate || new Date()).toDateString()}</div>
                </div>
                <div className="field">
                    <label>{labels.chapitre}</label>
                    <div>{familyMember.chapitre}</div>
                </div>

            </div>
            <div className="col-12 md:col-6">
                <div className="field">
                    <label>{labels.busLine}</label>
                    <div>{familyMember.busLine || '-'}</div>
                </div>
                <div className="field">
                    <label>{labels.tripType}</label>
                    <div>{familyMember.takesBus ? labels[familyMember.tripType] : '-'}</div>
                </div>
                <div className="field">
                    <label>{labels.boardingPoint}</label>
                    <div>{familyMember.getAboardStop || '-'}</div>
                </div>
                <div className="field">
                    <label>{labels.dropOffPoint}</label>
                    <div>{familyMember.dropOffStop || '-'}</div>
                </div>

            </div>
        </div>
        <div className="grid ui-fluid mt-3 submission">
            <div className="col-12 md:col-6">
                <div className="flex py-4 gap-2">
                    <Button
                        type="button"
                        label={labels.edit}
                        severity="secondary"
                        icon="pi pi-pencil"
                        onClick={() => {
                            sfd({ ...familyMember, currentStep: 0 });
                        }} />
                    <Button
                        type="button"
                        label={labels.addFamilyMember}
                        severity="secondary"
                        icon="pi pi-user-plus"
                        onClick={addmember} />
                    <Button
                        type="button"
                        label={labels.submission}
                        icon="pi pi-arrow-right"
                        iconPos="left"
                        onClick={jumptolasttab} />
                </div>
            </div>
            <div className="col-12 md:col-6">
                <div className="field">
                    <h4>{labels["price:"]}&nbsp;{(familyMember.currentStep == 4) &&
                        (exactPrice(familyMember).currency + " " + exactPrice(familyMember).price)}</h4>
                </div>
            </div>
        </div>
    </>
export default Summary;